// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__JDxJ-","content":"LayoutSettings_content__2NUf-"};